module.exports = __webpack_public_path__ + "img/set_primo_bagnetto.ad5b10f7.jpg";